export enum buildEnvType {
  prod = 'prod',
  dev = 'dev',
}

export const isProdEnv = () => {
  return process.env.REACT_APP_BUILD_ENV === buildEnvType.prod;
};
